export const hasStereocentersMapped = (route) => {
  const { stereocentersMapped } = route || {};

  if (Array.isArray(stereocentersMapped)) {
    return stereocentersMapped.length > 0;
  }

  return Boolean(stereocentersMapped);
};

export const filterRoutesByStereocentersMapped = (content = [], isStereospecificOnly = false) => {
  if (!isStereospecificOnly) {
    return content;
  }

  return content.filter((route) => hasStereocentersMapped(route));
};
